<template>
	<!-- This is used as a fake screensaver, when we are not used for a while -->
	<div id="museum-screensaver" :style="containerBackground">
		<div class="d-flex h-100">
			<div class="museum-screensaver-content w-100">
				<div id="museum-screensaver-carousel" class="carousel h-100" data-bs-touch="false" data-bs-ride="carousel">
					<div class="carousel-inner h-100">
						<div class="carousel-item h-100" :class="{active: index === 0 }" :data-bs-interval="content.time * 1000" v-for="(content, index) in tm('screensaver.content')" :key="content">
							<LogoSlide v-if="content.acf_fc_layout == 'logo'" />
							<ImageSlide v-if="content.acf_fc_layout == 'image'" :imageUrl="content.image" />
							<ArticleSlide v-if="content.acf_fc_layout == 'article'" :id="content.article" />
						</div>
					</div>
				</div>
				<div class="touch-me-layer animate__animated" id="screensaver-touchme-bg">
					<div class="h-100 row align-items-center justify-content-center d-none animate__animated" id="screensaver-touchme">
						<div class="col">
							<div class="d-flex h-100">
								<i class="touch-me-icon mx-auto animate__animated animate__infinite infinite animate__rubberBand"></i>
							</div>
							<h1 class="text-center">{{ t('screensaver_text.touch_me')}}</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="museum-footer museum-footer-screensaver">
			<div class="h-100 d-flex">
				<div class="ms-auto d-flex">
					<div v-if="$store.state.settings.languages.length > 1" class="h-100 d-flex">
						<!-- All the languages that are available, this is hardcoded for now -->
						<span @click="changeLocale(`${language}`)" class="h-100 d-flex museum-locale-btn" v-for="language in $store.state.settings.languages" :key="language">

							<i v-if="language == 'nl'" class="flag-icon flag-icon-nl my-auto"></i>
							<p v-if="language == 'nl'" class="museum-locale-text my-auto">Nederlands</p>

							<i v-if="language == 'en'" class="flag-icon flag-icon-gb my-auto"></i>
							<p v-if="language == 'en'" class="museum-locale-text my-auto">English</p>

							<i v-if="language == 'de'" class="flag-icon flag-icon-de my-auto"></i>
							<p v-if="language == 'de'" class="museum-locale-text my-auto">Deutsch</p>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Carousel } from "bootstrap";
import store from "../../store";

import LogoSlide from "@/components/screensaver/Logo.vue";
import ImageSlide from "@/components/screensaver/Image.vue";
import ArticleSlide from "@/components/screensaver/Article.vue";

export default {
	name: "Screensaver",
	components: {
		LogoSlide,
		ImageSlide,
		ArticleSlide,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	computed: {
		containerBackground() {
			if(store.state.settings.colors.other.use_image)
			{
				return `background-image: url('${store.state.settings.colors.other.background_image}');`;
			} else {
				return `background-color: ${store.state.settings.colors.other.background_color};`;
			}
		}
	},
	data() {
		return {
			debug: false, // If we want to debug
			cycle: true, // Enable/Disable cycling the carousel	
			active: false, // If the screensaver is active
			screensaverTimeout: undefined, // Handles the timeout for the screensaver
			enabled: store.state.settings.screensaver.enabled, // If the screensaver is enabled
			homescreen: store.state.settings.screensaver.homescreen, // If we should go back to home when screensaver is active
			carousel: null, // Reference to the carousel
			carouselTransition: store.state.settings.screensaver.transition, // The type of transition for the carousel
			touchMeBG: null, // The background for the touch me overlay
			touchMeEnabled: store.state.settings.screensaver.touchme.enabled, // If the touch me overaly is enabled
			touchMe: null, // The touch me element
			touchMeTimeout: undefined, // Handles the timeout for the touch me
			touchMeVisible: false,  // If the touch me is visible
			touchMeIntervalTime: store.state.settings.screensaver.touchme.interval, // Time between each touch me pop-up
			touchMeVisibleTime: store.state.settings.screensaver.touchme.visibleTime, // How long the touch me is visible
			globalVideoIsPlaying: false,
		};
	},
	mounted() {
		// If the screensaver is enabled
		if (this.enabled && !this.debug) {
			this.monitorInput();
		}

		// Permanently enable the screensaver so we can preview it easy :)
		if (this.debug) {
			document.getElementById("museum-screensaver").style.display = "block";

			if(this.touchMeEnabled)
			{
				this.touchMeStartTimeout();
			}
		}

		this.carousel = new Carousel(document.getElementById("museum-screensaver-carousel"));

		window.addEventListener('video_callback', this.videoEvent);

		this.touchMeBG = document.getElementById("screensaver-touchme-bg");
		this.touchMe = document.getElementById("screensaver-touchme");

		if (this.cycle) {
			this.carousel.cycle();
		}
	},
	methods: {
		monitorInput() {
			this.screensaverStartTimeout();

			document.getElementById("museum-screensaver").addEventListener("mousedown", this.deactivateScreensaver);
			document.getElementById("museum-screensaver").addEventListener("touchstart", this.deactivateScreensaver);

			window.addEventListener("touchstart", this.screensaverResetTimeout);
			window.addEventListener("mousedown", this.screensaverResetTimeout);
		},
		videoEvent(e) {
			if(e.detail.type == "start")
			{
				this.globalVideoIsPlaying = true;
			} else {
				this.globalVideoIsPlaying = false;
			}
		},
		activateScreensaver() {
			// Do not show while a video is playing
			if( this.globalVideoIsPlaying )
			{
				this.screensaverResetTimeout();
				return;
			}

			// If we should return to homescreen
			if (this.homescreen) {
				this.$router.push({ name: "Home" });
			}

			if(this.touchMeEnabled)
			{
				this.hideTouchMe(true);
			}
			
			// Reset to first slide
			if (this.carousel) {

				let classes = this.carouselTransition.split(" ");

				document.getElementById("museum-screensaver-carousel").classList.remove(...classes);
				this.carousel.to(0);
				document.getElementById("museum-screensaver-carousel").classList.add(...classes);
			}
			// Set is to active and show the element
			this.active = true;
			document.getElementById("museum-screensaver").style.display = "block";
		},
		deactivateScreensaver(e) {

			if (this.active) {
				e.preventDefault();
				// this.deactivateScreensaver();
				this.screensaverResetTimeout();
			}
			// Set it to non active and hide the element
			this.active = false;
			document.getElementById("museum-screensaver").style.display = "none";
		},
		screensaverResetTimeout() {
			// Reset the timeout again
			this.screensaverStopTimeout();
			this.screensaverStartTimeout();
		},
		screensaverStartTimeout() {
			this.screensaverTimeout = setTimeout(this.activateScreensaver, this.calculateScreensaverTime());
		},
		screensaverStopTimeout() {
			if (typeof this.screensaverTimeout !== "undefined") {
				clearTimeout(this.screensaverTimeout);
			}
		},
		showTouchMe() {

			if (!this.touchMeVisible) {
				this.touchMeVisible = !this.touchMeVisible;

				this.touchMeBG.classList.add("touch-me-background");
				this.touchMe.classList.remove("d-none");
				this.touchMe.classList.remove("animate__bounceOut");
				this.touchMe.classList.add("animate__bounceIn");
			}

			this.touchMeStopTimeout();

			this.touchMeTimeout = setTimeout(this.hideTouchMe, this.touchMeVisibleTime * 1000);
		},
		hideTouchMe( quick = false ) {
			// We quickly hide the element, so we don't see the out animation
			if(quick)
			{
				this.touchMe.classList.add("d-none");
			}

			if (this.touchMeVisible) {
				this.touchMeVisible = !this.touchMeVisible;

				this.touchMeBG.classList.remove("touch-me-background");
				this.touchMe.classList.remove("animate__bounceIn");
				this.touchMe.classList.add("animate__bounceOut");
			}

			this.touchMeStopTimeout();
			this.touchMeStartTimeout();
		},
		touchMeStartTimeout() {
			this.touchMeTimeout = setTimeout(this.showTouchMe, this.touchMeIntervalTime * 1000);
		},
		touchMeStopTimeout() {
			if (typeof this.touchMeTimeout !== "undefined") {
				clearTimeout(this.touchMeTimeout);
			}
		},
		calculateScreensaverTime() {
			let val = store.state.settings.screensaver.time.value;
			let type = store.state.settings.screensaver.time.type;

			return ( val * ( type == "minutes" ? 60 : 1 ) ) * 1000;
		}
	},
};
</script>

<style scoped>
.touch-me-layer {
	z-index: var(--global-z-index-screensaver-touch-me);
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgb(0, 0, 0, 0);
}

.touch-me-background {
	background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Screensaver */

#museum-screensaver {
    display: none;
    content: "";
    position: fixed;
    z-index: var(--global-z-index-screensaver);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    /* background-image: url(../img/background-home.png); */
}


/* #museum-screensaver::before {
    content: '';
    position: absolute;
    clip-path: polygon(35% 0, 100% 0, 100% 100%, 0% 100%);
    background-color: rgba(8, 35, 42, .85);
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: var(--global-z-index-screensaver);
} */

.museum-screensaver-content {
    z-index: var(--global-z-index-screensaver);
}

#museum-screensaver h1 {
    color: #fff;
    font-size: 150px;
    z-index: var(--global-z-index-screensaver);
}

.touch-me-icon {
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    display: inline-block;
	background-image: url("~@/assets/img/icons/touch-me.svg");
    height: 150px;
    width: 150px;
    z-index: var(--global-z-index-screensaver);
}
</style>